import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import useStyles from "./Styles";

interface PremiumDonutChartProps {
  data: any;
  handleSourceSelected: any;
  openModal: any;
}

const PremiumDonutChart: React.FC<PremiumDonutChartProps> = ({
  data,
  handleSourceSelected,
  openModal,
}) => {
  const { classes } = useStyles();
  const [activeItem, setActiveItem] = useState<string | null>(null);

  const handleClick = (source: string) => {
    handleSourceSelected(source);
    openModal();
  };

  return (
    <Box className={classes.contentContainer}>
      {/* Grid-Based Legend (Now Primary View) */}
      <Box className={classes.gridContainer}>
        {data.map((item: any) => (
          <Box
            key={item.label}
            className={classes.sourceCard}
            onMouseEnter={() => setActiveItem(item.label)}
            onMouseLeave={() => setActiveItem(null)}
            sx={{
              borderLeft: `4px solid ${item.color}`,
              backgroundColor:
                activeItem === item.label ? "#fff" : "rgba(255, 255, 255, 0.6)",
            }}
          >
            <Box className={classes.cardHeader}>
              <Box
                className={classes.sourceIconBox}
                sx={{ backgroundColor: item.color }}
              >
                <Typography variant="caption" sx={{ fontWeight: 800 }}>
                  {item.label.charAt(0)}
                </Typography>
              </Box>
              <Typography className={classes.sourceCount}>
                {item.count}
              </Typography>
            </Box>
            <Typography className={classes.sourceLabel}>
              {item.label}
            </Typography>
            <Box
              className={classes.viewButton}
              onClick={() => handleClick(item.label)}
            >
              View
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PremiumDonutChart;
